import { Input } from "@/components/ui/input"
import { useTranslation } from "@/hooks/useTranslation/useTranslation"
import { cn } from "@/lib/utils"
import { Search, X } from "lucide-react"

interface SearchFieldProps {
  value: string
  onChange: (value: string) => void
  placeholder: string
  className?: string
  onClear?: () => void
}

export function SearchField({
  value,
  onChange,
  placeholder,
  className,
  onClear,
}: SearchFieldProps) {
  const { translate } = useTranslation()

  return (
    <div className={cn("relative w-full max-w-64 flex-1", className)}>
      <Search className="absolute left-2.5 top-1/2 size-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        placeholder={placeholder}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className={cn(
          "h-8 border-grey4 pl-8 text-xs shadow-none focus-visible:border-yellow1 focus-visible:ring-0",
          onClear && value && "pr-7",
        )}
      />
      {onClear && value && (
        <button
          type="button"
          aria-label={translate("SEARCH_FIELD/CLEAR")}
          onClick={onClear}
          className="absolute right-2.5 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
        >
          <X className="size-3.5" />
        </button>
      )}
    </div>
  )
}
